import { FC, useState } from 'react';
import {
  Center,
  Heading,
  VStack,
  Button,
  Box,
  Flex,
  Spinner,
} from '@chakra-ui/react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from '../../consts/routes';
import { FaEdit, FaPlus } from 'react-icons/fa';
import Pagination from '@olagg/ui-kit/Pagination';
import CardDeckTable from './Table';
import { useAdminCardDecks } from '@olagg/api-hooks';

const CardDeck: FC = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState({
    page: Number(searchParams.get('page') || 1),
    limit: Number(searchParams.get('limit') || 100)
  });

  const { page, limit } = filter;
  const { data, isLoading, mutate } = useAdminCardDecks();

  const onFilter = ({
    name,
    value
  }: { name: string, value: any }) => {
    setFilter({ ...filter, [name]: value });
    if (value) searchParams.set(name, value);
    else searchParams.delete(name);
    setSearchParams(searchParams);
  };

  return (
    <Center w='full' pb={4}>
      <VStack color={'white'} w='full'>
        <Heading my={2}>Juegos de Cartas</Heading>
        <Flex w='full' alignItems='center' justifyContent='space-between'>
          <Flex>
            <Button
              mt='2' mr='2'
              variant="outlinedGradient"
              leftIcon={<FaPlus />}
              onClick={() => navigate(ROUTES.CARD_DECKS.create)}
            >
              Nuevo Juego de Cartas
            </Button>
          </Flex>
        </Flex>

        {isLoading ? (
          <Spinner />
        ) : (
          <Box overflow="auto" mt={4} w="80vw" h="55vh">
            <CardDeckTable cardDecks={data?.decks || []} onUpdate={mutate} />
          </Box>
        )}

        {/* <Pagination
          params={{ limit, page, count }}
          onClick={page => onFilter({ name: 'page', value: String(page + 1) })}
          onLimitChange={val => onFilter({ name: 'limit', value: val })}
          hideLimitInput
        /> */}
      </VStack>
    </Center>
  );
};

export default CardDeck;
export { CreateCardDeck } from './Create'
export { EditCardDeck } from './Edit'
